import { render, staticRenderFns } from "./verifikasiDisposisi.vue?vue&type=template&id=2bbe21ba"
import script from "./verifikasiDisposisi.vue?vue&type=script&lang=js"
export * from "./verifikasiDisposisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QList,QItemLabel,QItem,QItemSection,QIcon,QMenu,QDialog,QCardActions,QBtnGroup,QSelect,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QList,QItemLabel,QItem,QItemSection,QIcon,QMenu,QDialog,QCardActions,QBtnGroup,QSelect})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
